
import { ReactElement, createContext, useContext, useEffect, useState } from "react";
import { SettingModel } from "../../model/setting-model";
import { StorageKey } from "../../common/const/storage-key";

const SettingContext = createContext<SettingType>(null!)

interface SettingType {
	setting: SettingModel
	setSetting: (setting: SettingModel) => void
	notify: () => any
}

export function useSettingProvider() {
	return useContext(SettingContext)
}


export function SettingProvider({ children }: { children: ReactElement }) {
	const [setting, setSetting] = useState<SettingModel>(SettingModel.default())

	function notify() {
		const json = localStorage.getItem(StorageKey.setting)
		if (!json) return
		setSetting(SettingModel.fromJson(JSON.parse(json)))
	}

	useEffect(() => {
		notify()
	}, [])

	const value = {
		setting,
		setSetting,
		notify,
	}
	return (
		<SettingContext.Provider value={value}>
			{children}
		</SettingContext.Provider>
	)
}
